// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var EntitiesController = function ($scope, $routeParams, Entity, $http) {
    $scope.wasSearching = false;
    $scope.filters = {};
    $scope.updateFilter = function () {
        $scope.entities = $scope.paginator(function (options, callback) {
            return Entity.query(options, function () { callback(); $scope.wasSearching = options.search; });
        }, { search: $scope.filters.search, PaymentProvider: $scope.filters.provider, PaymentMethod:$scope.filters.method, Feature : $scope.filters.feature }, 20);
    };

    $scope.resetFiltersAndRead = function () {
        $scope.filters.search = '';
        $scope.filters.provider = '';
        $scope.filters.method = '';
        $scope.filters.feature = '';
        $scope.updateFilter();
    }

    $scope.resetFiltersAndRead();

    $scope.allAvailableFeatures = [ ];
    
    $http.get('/api/v1/features', {})
        .success(function (result) { $scope.allAvailableFeatures = result });
};
EntitiesController.$inject = ['$scope', '$routeParams', 'Entity', '$http'];
